<template>
  <div :key="index" :class="`cat-item-holder ${index<total-1?'border-bottom':''}`">
    <div class="cat-item">
      <img @click.stop="toggleLightBox" :src="item.img[0]" alt class="cat-item-img" />
      <div @click="openDetails" class="cat-item-right">
        <div class="cat-item-name">{{item.name}}</div>
        <div class="cat-item-description">{{item.description}}</div>
        <div class="cat-item-price">{{item.price| currency('€')}}</div>
        <div class="add-to-cart mt-1">
          <div @click.stop="addToCart" v-if="!itemExists" class="cart-b-holder">
            <b-icon icon="inbox-fill" class="cart-button ml-auto"></b-icon>
          </div>
          <div v-else class="quantity-holder d-flex">
            <div @click.stop="reduceQuantity" class="cart-b-holder">
              <b-icon icon="dash"></b-icon>
            </div>
            <span class="quantity mx-2">{{itemExists.quantity}}</span>
            <div @click.stop="addToCart" class="cart-b-holder">
              <b-icon icon="plus"></b-icon>
            </div>
          </div>
        </div>
      </div>
      <FsLightbox :slide="slide" :toggler="toggler" :sources="item.img" type="image" />
    </div>
    <b-modal :id="item.id+index" size="md" title="Item Details">
      <el-carousel height="200px">
        <template v-for="(img,index) in item.img">
          <el-carousel-item :key="index">
            <img @click.stop="openLightBox(index+1)" class="d-block" :src="img" alt="First slide" />
          </el-carousel-item>
        </template>
      </el-carousel>
      <div class="cat-item-name mt-2">{{item.name}}</div>
      <div class="full-description mt-1">{{item.description}}</div>
      <div class="cat-item-price mt-1">{{item.price| currency('€')}}</div>
      <div class="add-to-cart mt-1">
        <div @click.stop="addToCart" v-if="!itemExists" class="cart-b-holder">
          <b-icon icon="inbox-fill" class="cart-button ml-auto"></b-icon>
        </div>
        <div v-else class="quantity-holder d-flex">
          <div @click.stop="reduceQuantity" class="cart-b-holder">
            <b-icon icon="dash"></b-icon>
          </div>
          <span class="quantity mx-2">{{itemExists.quantity}}</span>
          <div @click.stop="addToCart" class="cart-b-holder">
            <b-icon icon="plus"></b-icon>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer="{ }">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FsLightbox from "fslightbox-vue";
import { Carousel, CarouselItem } from "element-ui";
//import Botton from "../Botton"
export default {
  props: {
    index: String,
    item: Object,
    total: Number,
    menuId: String,
    editable: Boolean
  },
  components: {
    FsLightbox,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
    //Botton
  },
  data() {
    return {
      toggler: false,
      slide: 1
    };
  },
  methods: {
    toggleLightBox() {
      this.toggler = !this.toggler;
    },
    openLightBox(index) {
      this.slide = index;
      this.$bvModal.hide(this.item.id + this.index);
      this.toggleLightBox();
    },
    openDetails() {
      this.$bvModal.show(this.item.name + this.index);
    },
    addToCart() {
      this.$store.dispatch("Cart/addToCart", this.item);
    },
    reduceQuantity() {
      this.$store.dispatch("Cart/reduceQuantity", this.item);
    }
  },
  computed: {
    menu() {
      return this.$store.state.MenuView.currentMenu;
    },
    itemExists() {
      if (!this.menu) {
        return null;
      }
      if (!this.$store.state.Cart.cart[this.menu.id]) {
        return null;
      } else {
        return this.$store.state.Cart.cart[this.menu.id][this.item.id];
      }
      /* return this.menu
        ? this.$store.state.Cart.cart[this.menu.id][this.item.id]
        : {}; */
    }
  },
  mounted() {}
};
</script>

<style>
.cat-item-holder {
  padding-bottom: 10px;
}

.cat-item-holder.border-bottom {
  border-bottom: 1px solid #ddd;
}

.cat-item {
  display: grid;
  grid-template-columns: 90px 1fr;
  height: 90px;
  grid-gap: 10px;
  position: relative;
}

.cat-item .dropdown-wrapper {
  color: white;
  position: absolute;
  top: -30px;
  right: 0px;
  z-index: 3;
}

.cat-item-img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cat-item-bottom {
  display: flex;
  justify-content: flex-end;
}

.cat-item-holder .cat-item-bottom .mcat-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mcat-wrapper .mcat-top .mcat-top-btn:hover {
  color: #2ca8ff;
}

.cat-item-name {
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
}
.cat-item-price {
  font-size: smaller;
}

.cat-item-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: small;
  margin-bottom: 0;
}

.full-description {
  line-height: initial;
  text-align: start;
  word-break: break-all;
  margin: 10px 0;
}

.cat-item-right {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-b-holder {
  background: #f96332;
  color: white;
  width: 20px;
  text-align: center;
  border-radius: 2px;
}
</style>